import { ReportDef } from './reportRegistry';

export const AVATAR_COLORS = ['#dfe4f0', '#f5e0d3', '#dfe8df', '#eddce8', '#d9e6ef', '#eee1cf', '#e2d9f0', '#d6e6e2'];

export type ExtraFilter = {
    label: string;
    active?: boolean;
    summary?: string;
    badge?: number;
};

export type StaticReportView = {
    report: ReportDef;
    extraFilters: ExtraFilter[];
    extraFilterLabel?: string;
    countText: string;
    sortOptions: string[];
    columns: string[];
    footnotes?: string[];
    actions?: 'standard' | 'upload';
};

export const EVENTS_EXTRA: ExtraFilter[] = [
    { label: 'Event Type', active: true, summary: 'Reunion, Cultural Fest', badge: 2 },
    { label: 'Event Date' },
    { label: 'Role' },
    { label: 'Mode (On-campus / Off / Online)' },
];

export const EVENTS_ROWS = [
    ['Anuradha Gautam', 'B.Tech · 2020', "Homecoming '24", 'Reunion', 'Attendee', '12 Nov 2024', 'On-campus'],
    ['Aditya Sharma', 'M.Tech · 2017', 'Campus Placement Drive', 'Recruiter', 'Recruiter', '08 Oct 2024', 'On-campus'],
    ['K C Ramaswamy', 'B.Des · 2021', 'Riviera Alumni Panel', 'Cultural Fest', 'Panelist', '22 Feb 2025', 'On-campus'],
    ['Namita Dube', 'B.Arch · 2019', 'Global Alumni Meet — Boston', 'Reunion', 'Attendee', '14 Sep 2024', 'Off-campus'],
    ['Rahul Menon', 'MBA · 2015', 'AI in FinTech Webinar', 'Webinar', 'Speaker', '03 Jul 2024', 'Online'],
    ['Priya Iyer', 'B.Tech · 2018', 'TechFest 2024', 'Cultural Fest', 'Judge', '19 Oct 2024', 'On-campus'],
    ['Vikram Rao', 'M.Tech · 2016', 'Annual Alumni Dinner', 'Reunion', 'Attendee', '23 Dec 2024', 'On-campus'],
    ['Sneha Kulkarni', 'MBA · 2019', 'Startup Pitch Day', 'Guest Lecture', 'Mentor', '15 Aug 2024', 'On-campus'],
];

export const PLACEMENTS_EXTRA: ExtraFilter[] = [
    { label: 'Top Companies' },
    { label: 'Placed Company' },
    { label: 'Current Company' },
    { label: 'AHLI Quadrant' },
    { label: 'Salary Power Quadrant' },
    { label: 'Batch Percentile', active: true, summary: 'Top 10%' },
    { label: 'Placement Focus' },
    { label: 'Recruiting Company (Came in Last)' },
    { label: 'Lapsed Company' },
];

export const PLACEMENT_ROWS: Array<{
    name: string;
    batch: string;
    placed: string;
    lapsed?: boolean;
    current: string;
    switched?: boolean;
    desig: string;
    ctc: string;
    ahli: string | null;
    spm: string | null;
    pct: string;
}> = [
    { name: 'Rahul Menon', batch: 'MBA · 2015', placed: 'Goldman Sachs', current: 'Goldman Sachs', desig: 'VP — Investment Banking', ctc: '₹ 68 L', ahli: 'Powerhouse', spm: 'Core Powerhouse', pct: 'Top 10%' },
    { name: 'Sneha Kulkarni', batch: 'MBA · 2019', placed: 'McKinsey & Co', current: 'McKinsey & Co', desig: 'Engagement Manager', ctc: '₹ 52 L', ahli: 'Powerhouse', spm: 'Core Powerhouse', pct: 'Top 10%' },
    { name: 'Aditya Sharma', batch: 'M.Tech · 2017', placed: 'Google', current: 'Google', desig: 'Staff Software Engineer', ctc: '₹ 82 L', ahli: 'Powerhouse', spm: 'Core Powerhouse', pct: 'Top 10%' },
    { name: 'Karan Malhotra', batch: 'B.Tech · 2016', placed: 'Infosys', current: 'Meta (London)', switched: true, desig: 'Senior SWE', ctc: '₹ 96 L', ahli: 'Sleeping Giant', spm: 'Elite but Limited', pct: 'Top 10%' },
    { name: 'Siddharth Verma', batch: 'MBA · 2012', placed: 'Deloitte', lapsed: true, current: 'Bain Capital', switched: true, desig: 'Director', ctc: '₹ 1.2 Cr', ahli: null, spm: null, pct: 'Top 10%' },
    { name: 'Arjun Nair', batch: 'B.Tech · 2014', placed: 'Flipkart', current: 'GreenPass (Founder)', switched: true, desig: 'Founder & CEO', ctc: '₹ 88 L', ahli: 'Overachiever', spm: 'Elite but Limited', pct: 'Top 10%' },
    { name: 'Aditi Rao', batch: 'B.Tech · 2011', placed: 'Cognizant', lapsed: true, current: 'Salesforce', switched: true, desig: 'Distinguished Engineer', ctc: '₹ 1.1 Cr', ahli: null, spm: null, pct: 'Top 10%' },
    { name: 'Priya Iyer', batch: 'B.Tech · 2018', placed: 'Microsoft', current: 'Microsoft', desig: 'Senior SDE', ctc: '₹ 54 L', ahli: 'Powerhouse', spm: 'Core Powerhouse', pct: 'Top 10%' },
];

export const PLACEMENT_FOOTNOTES = [
    'AHLI Quadrant: Powerhouse · Sleeping Giant · Overachiever · Question Mark — company influence + hiring depth over the last 3–5 batches.',
    'SPM Quadrant: Core Powerhouse · Elite but Limited · Safety Net · Dead Zone — total offers + mean salary over the last 3–5 batches.',
    'Blank quadrants: older batches whose placed company has not visited in the last 3–5 years still appear, without quadrant classification.',
    'Lapsed Company: used to recruit but has not visited in the last 3 years (needs 5+ years of visit data).',
];

export const REWARDS_EXTRA: ExtraFilter[] = [
    { label: 'Awarding Body', active: true, summary: 'Institute' },
    { label: 'Recognition Type' },
    { label: 'Award Category (custom)' },
    { label: 'Year' },
    { label: 'Level (National / International / Regional)' },
];

export const REWARDS_ROWS = [
    ['Priya Iyer', 'B.Tech · 2018', 'Distinguished Alumni Award', 'VIT University', 'Academic Excellence', 'Institute', '2024'],
    ['Rohan Bhatia', 'MBA · 2013', 'Padma Shri', 'Government of India', 'Business Leadership', 'National', '2023'],
    ['Sneha Kulkarni', 'MBA · 2019', 'Forbes 30 Under 30 — Asia', 'Forbes Media', 'Entrepreneurship', 'International', '2024'],
    ['Rahul Menon', 'MBA · 2015', 'Excellence in Finance Award', 'VIT University', 'Career Achievement', 'Institute', '2024'],
    ['Karan Malhotra', 'B.Tech · 2016', 'MIT TR35 Innovator', 'MIT Tech Review', 'Technology', 'International', '2023'],
    ['Neha Kapoor', 'B.Des · 2019', 'Red Dot Design Award', 'Red Dot GmbH', 'Design', 'International', '2024'],
    ['Arjun Nair', 'B.Tech · 2014', 'ET Entrepreneur of the Year', 'Economic Times', 'Entrepreneurship', 'National', '2024'],
    ['Aditi Rao', 'B.Tech · 2011', 'Distinguished Alumni Award', 'VIT University', 'Career Achievement', 'Institute', '2023'],
];

export const GUIDANCE_EXTRA: ExtraFilter[] = [
    { label: 'Activity Type' },
    { label: 'Initiative' },
    { label: 'Date Range' },
    { label: 'Status', active: true, summary: 'Active mentors' },
    { label: 'Audience (UG / PG / School)' },
];

export const GUIDANCE_ROWS = [
    ['Rahul Menon', 'MBA · 2015', 'Mentorship', 'Career Guidance — Finance track', 'Alumni Mentorship 2024', '12', '28 Nov 2024'],
    ['Sneha Kulkarni', 'MBA · 2019', 'Webinar', 'How to break into consulting', 'Career Talks', '4', '15 Oct 2024'],
    ['Aditya Sharma', 'M.Tech · 2017', 'Guest Lecture', 'System Design Deep Dive', 'Dept of CSE', '6', '22 Nov 2024'],
    ['Vikram Rao', 'M.Tech · 2016', 'Mentorship', 'Cloud Architecture Mentor Circle', 'Alumni Mentorship 2024', '18', '30 Nov 2024'],
    ['Priya Iyer', 'B.Tech · 2018', 'Webinar', 'Women in Tech Leadership', 'Career Talks', '3', '07 Sep 2024'],
    ['Arjun Nair', 'B.Tech · 2014', 'Guest Lecture', 'Building a Startup', 'Dept of Management', '5', '19 Oct 2024'],
    ['Ananya Sen', 'M.Tech · 2018', 'Short-term Project', 'ML for Agri-tech', 'Capstone Program', '1', 'Ongoing'],
    ['Aditi Rao', 'B.Tech · 2011', 'Mentorship', 'Distinguished Alumni Mentor', 'Alumni Mentorship 2024', '22', '30 Nov 2024'],
];

export const STORIES_EXTRA: ExtraFilter[] = [
    { label: 'Segment', active: true, summary: 'Super Achiever, Hustler', badge: 2 },
    { label: 'Marketability Quotient' },
    { label: 'Alma Mater Pride' },
    { label: 'Story Published' },
];

export const STORIES_ROWS = [
    ['Rahul Menon', 'MBA · 2015', 'Super Achiever', 'VP — Goldman Sachs', 'From campus placement to Wall Street VP in 9 years', 'Published on Website'],
    ['Sneha Kulkarni', 'MBA · 2019', 'Super Achiever', 'Engagement Manager — McKinsey', 'Youngest EM in her MBB office', 'Published + Social'],
    ['Arjun Nair', 'B.Tech · 2014', 'Hustler', 'Founder & CEO — GreenPass', 'Built a $40M carbon-credit startup from scratch', 'Draft'],
    ['Aditi Rao', 'B.Tech · 2011', 'Super Achiever', 'Distinguished Engineer — Salesforce', "Rose to DE in 13 years — one of India's youngest", 'Published on Website'],
    ['Karan Malhotra', 'B.Tech · 2016', 'Achiever', 'Senior SWE — Meta London', 'Ivy League MS → Meta L6 in 6 years', 'Ready for Review'],
    ['Meera Krishnan', 'M.Sc · 2020', 'Late Bloomer', 'Data Scientist — Amazon', 'Struggled early, cleared FAANG in 3 attempts', 'Not Published'],
    ['Neha Kapoor', 'B.Des · 2019', 'Hustler', 'Founder — Loomcraft Studio', 'Bootstrapped D2C brand to ₹18Cr ARR', 'Published + Social'],
    ['Priya Iyer', 'B.Tech · 2018', 'Achiever', 'Senior SDE — Microsoft', 'MS from CMU, now leading Copilot infra team', 'Published on Website'],
];

export const STORIES_FOOTNOTES = [
    'Super Achiever: Top colleges for UG/PG + top companies throughout.',
    'Achiever: Joined a top institute for UG/PG, now running own company or in a top company.',
    'Hustler: Running own company, first-gen entrepreneur, no top-tier UG/PG background.',
    'Late Bloomer: Reached a good position despite a regular education background.',
];

export const UPLOAD_ROWS = [
    ['30 Nov 2024, 4:22 PM', 'Placements', 'Placements_Batch2024_v3.xlsx', 'Rekha Aggarwal', '0', '218', '4', 'Completed', 'ok'],
    ['30 Nov 2024, 11:08 AM', 'Event Participation', 'Homecoming24_Attendees.csv', 'Rekha Aggarwal', '342', '18', '0', 'Completed', 'ok'],
    ['28 Nov 2024, 6:41 PM', 'Rewards & Recognitions', 'Awards_2024_Annual.xlsx', 'Priya Menon', '46', '2', '1', 'Completed', 'ok'],
    ['27 Nov 2024, 2:15 PM', 'Ability Markers', 'Markers_F500_Update.xlsx', 'Rekha Aggarwal', '0', '1,204', '12', 'Completed with warnings', 'warn'],
    ['25 Nov 2024, 9:04 AM', 'Guidance Champions', 'Mentors_Nov24.csv', 'Anand Rao', '28', '6', '0', 'Completed', 'ok'],
    ['24 Nov 2024, 5:33 PM', 'Placements', 'Placements_Batch2024_v2.xlsx', 'Rekha Aggarwal', '–', '–', '–', 'Failed — 14 header mismatches', 'err'],
    ['22 Nov 2024, 10:52 AM', 'Success Stories', 'StoriesQ4.xlsx', 'Priya Menon', '12', '4', '0', 'Completed', 'ok'],
    ['19 Nov 2024, 3:18 PM', 'Event Participation', 'OffCampus_London_Meet.csv', 'Anand Rao', '86', '0', '0', 'Completed', 'ok'],
];
